// Mapping role.displayName → human-readable group. Hardcoded because groups
// do not exist as a backend concept yet. Matching is done by displayName as
// requested by product, so the labels here mirror the strings the user sees.
export const ROLE_GROUPS: { label: string; roleDisplayNames: string[] }[] = [
  {
    label: 'Ejecutivo',
    roleDisplayNames: [
      'Clientes - Ejecutivo de Ventas sin Templates',
      'Visualizador de funnel',
      'Mensajeria',
      'Clientes - Ejecutivo por proyectos',
      'Clientes - Ejecutivo de Ventas',
      'Clientes - Ejecutivo de Ventas y sin asignar',
      'Clientes - General',
    ],
  },
  {
    label: 'Jefatura',
    roleDisplayNames: ['Reportes', 'Administrador de campañas'],
  },
  {
    label: 'Manager',
    roleDisplayNames: ['Administrador de Funnel', 'Clientes - Manager'],
  },
];

export const OTHERS_GROUP_LABEL = 'Otros';

export interface RoleGroup<T> {
  label: string;
  roles: T[];
}

// Groups a list of roles using ROLE_GROUPS. Any role not present in a group
// falls into "Otros" (kept at the end). Groups with no matching roles are
// filtered out so the UI does not render empty headers.
export const groupRoles = <T extends { displayName: string }>(roles: T[]): RoleGroup<T>[] => {
  const groups: RoleGroup<T>[] = ROLE_GROUPS.map((g) => ({
    label: g.label,
    roles: roles.filter((r) => g.roleDisplayNames.includes(r.displayName)),
  }));
  const assigned = new Set(ROLE_GROUPS.flatMap((g) => g.roleDisplayNames));
  const others = roles.filter((r) => !assigned.has(r.displayName));
  if (others.length > 0) {
    groups.push({ label: OTHERS_GROUP_LABEL, roles: others });
  }
  return groups.filter((g) => g.roles.length > 0);
};
